import React from 'react';
import { Modal, Checkbox, Button } from 'antd';
import { AffectedTasksTable } from '../../affected-tasks-table';
import { useClearDagRunDialog } from './use-clear-dag-run-dialog';

type ClearDagRunDialogProps = {
    dagId: string;
    runId: string;
    onClose: () => void;
    onCleared: () => void;
};

/*
 * Confirms clearing an entire DAG run (optionally only-failed / on the latest DAG version),
 * with a live dry-run preview of every task instance that would be affected
 */
export function ClearDagRunDialog({ dagId, runId, onClose, onCleared }: ClearDagRunDialogProps) {
    const { onlyFailed, setOnlyFailed, runOnLatestVersion, setRunOnLatestVersion, affectedTasks, isLoadingPreview, isClearing, handleConfirm } = useClearDagRunDialog(dagId, runId, () => {
        onCleared();
        onClose();
    });

    return (
        <Modal
            visible
            className="airflowDashboardRoot"
            title={`Clear DAG Run "${runId}"`}
            onCancel={onClose}
            footer={[
                <Button key="cancel" onClick={onClose}>
                    Cancel
                </Button>,
                <Button key="confirm" type="danger" onClick={handleConfirm} disabled={isClearing || affectedTasks.length === 0}>
                    {isClearing ? 'Clearing…' : 'Confirm'}
                </Button>,
            ]}
        >
            <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', marginBottom: 16 }}>
                <Checkbox checked disabled>
                    Clear existing tasks
                </Checkbox>
                <Checkbox checked={onlyFailed} onChange={(e) => setOnlyFailed(e.target.checked)}>
                    Clear only failed tasks
                </Checkbox>
                <Checkbox checked={runOnLatestVersion} onChange={(e) => setRunOnLatestVersion(e.target.checked)}>
                    Run on latest version
                </Checkbox>
            </div>
            <AffectedTasksTable tasks={affectedTasks} isLoading={isLoadingPreview} />
        </Modal>
    );
}
